import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";
import { LASTEST_TAB } from "../const";

const SpecificTab = [
  {
    id: LASTEST_TAB,
    text: "Báo cáo mới",
  },
];

const researchReportSelector = (state: RootState) => state.researchReport;

const tabsContentSelector = createSelector(
  researchReportSelector,
  (state) => state.getTabsContent
);

export const tabsContentDataSelector = createSelector(
  tabsContentSelector,
  (state) => {
    const formattedTabs = state.data.map(({ id, ...rest }) => ({
      ...rest,
      id: id.toString(),
    }));
    return [...SpecificTab, ...formattedTabs];
  }
);

export const filterResearchReport = (state: RootState) =>
  state.researchReport.filterListResearchReport;
export const filterResearchReportSelector = createSelector(
  filterResearchReport,
  (state) => state
);

const listResearchReport = createSelector(
  researchReportSelector,
  (state) => state.getListResearchReport
);

export const listResearchReportDataSelector = createSelector(
  listResearchReport,
  (state) => state.data
);

export const listResearchReportStatusSelector = createSelector(
  listResearchReport,
  (state) => state.status
);

const detailResearchReport = (state: RootState) =>
  state.researchReport.getResearchReportDetail;

export const detailResearchReportDataSelector = createSelector(
  detailResearchReport,
  (state) => state.data
);

export const detailResearchReportStatusSelector = createSelector(
  detailResearchReport,
  (state) => state.status
);
